/*
 * Jira Ticket:
 * Created Date: Mon, 20th Apr 2020, 18:02:15 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';
import axios from 'axios';

// File upload response structure
// type UploadTowerFileResponse {
//   files: [FileUpload!]!
// }
// type FileUpload {
//   id: ID!
//   url: URL!
//   uploadUrl: URL!
//   contentType: String!
// }

const UploadTowerTypeImageMutation = gql`
  mutation uploadTowerTypeImage($input: UploadTowerTypeImageInput!) {
    data: uploadTowerTypeImage(input: $input) {
      files {
        id
        url
        uploadUrl
        contentType
      }
    }
  }
`;

export default async ({ client, questions }) => {
  // File upload request structure
  // input: {files: [FileUploadInput] }
  // input FileUploadInput {
  //     filename: String!
  //     contentType: String
  //   }
  const questionsWithRawFiles = questions.filter(questionWithImg =>
    questionWithImg.image.hasOwnProperty('rawFile')
  );
  const input = {
    files: questionsWithRawFiles.map(questionWithImg => {
      return {
        filename: questionWithImg.image.rawFile.name,
        contentType: questionWithImg.image.rawFile.type,
      };
    }),
  };
  if (input.files.length > 0) {
    const uploadRequest = await client.mutate({
      mutation: UploadTowerTypeImageMutation,
      variables: {
        input,
      },
    });
    const responseFiles = uploadRequest.data.data.files;
    const putRequests = [];
    for (let i = 0; i < questionsWithRawFiles.length; i++) {
      const uploadQuestionImg = questionsWithRawFiles[i].image;
      const responseFile = responseFiles[i];
      putRequests.push(
        axios.put(responseFile.uploadUrl, uploadQuestionImg.rawFile, {
          headers: {
            'Content-Type': responseFile.contentType,
          },
        })
      );
    }
    await axios.all(putRequests);
    return uploadRequest;
  }
  return;
};
